import * as React from 'react';
import { IContactInfo } from '../../../Models/ContactInfo/IContactInfo';
import { ContactInfoView } from './ContactInfoView';
import * as Services from '../../../Services/Services';
import { IStatusMessage } from '../../../Models/IStatusMessage';
import { IContactInfoApi } from '../../../Services/API/ContactInfo/IContactInfoApi';
import { MessageBarType } from '@fluentui/react';
import { ERPSystemEnum } from '../../../Models/ContactInfo/ERPSystemEnum';


interface IContactInfoProps {

}


export const ContactInfo: React.FunctionComponent<IContactInfoProps> = (props) => {

    const [contactInfo, setContactInfo] = React.useState<IContactInfo>({
        bankAccount: "", city: "", company: "", dic: "", email: "", iban: "", ic: "",
        id: 1, invoiceNoTemplate: "", phoneNumber: "", postalCode: "", registrationInfo: "", street: "", web: "",
        defaultDueDays: 0, dphSnizena1: 0, dphSnizena2: 0, dphZaklad: 0,
        erpSystem: ERPSystemEnum.None,
        eShopId: "",
        kodDPH: "",
        predkontace: "",
        exportovatDnyPoVytvoreni:0,
    });
    const [isLoading, setIsLoading] = React.useState<boolean>(false);
    const [statusMessage, setStatusMessage] = React.useState<IStatusMessage>()


    const loadData = async () => {
        setIsLoading(true);
        setStatusMessage(undefined);
        const contactInfoApi = Services.ServicesProvider.GetService<IContactInfoApi>(Services.ContactInfoApi);
        const contactInfo = await contactInfoApi.getContactInfo();

        if (contactInfo.isSuccess && contactInfo.data) {
            setContactInfo(contactInfo.data);
            setStatusMessage(undefined);
        }
        else {
            setStatusMessage({ message: contactInfo.message, type: MessageBarType.error });
        }
        setIsLoading(false);
    }

    const saveData = async (data?: IContactInfo) => {
        if (data) {
            setIsLoading(true);
            setStatusMessage(undefined);
            const contactInfoApi = Services.ServicesProvider.GetService<IContactInfoApi>(Services.ContactInfoApi);
            const contactInfo = await contactInfoApi.saveContactInfo(data);

            if (contactInfo.isSuccess && contactInfo.data) {
                setContactInfo(contactInfo.data);
                setStatusMessage(undefined);
            }
            else {
                setStatusMessage({ message: contactInfo.message, type: MessageBarType.error });
            }
            setIsLoading(false);
        }
    }

    React.useEffect(() => {
        loadData();
    }, [])

    const changeInfoProperty = (key: string, value: any) => {
        if (contactInfo) {
            setContactInfo({ ...contactInfo, [key]: value });
        }
    }
    return (<ContactInfoView saveData={saveData} changeInfoProperty={changeInfoProperty} isLoading={isLoading} info={contactInfo} />)
}
